import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  PostApplicationsInsurancePwdBody,
  PostApplicationsInsurancePwdResponse,
} from "api/api/applicationsApi/types";

export const postApplicationsInsurancePwd = createAsyncThunk<
  PostApplicationsInsurancePwdResponse,
  PostApplicationsInsurancePwdBody
>("applications/postApplicationsInsurancePwd", async (body, { rejectWithValue }) => {
  try {
    const data = await ApplicationsAPI.postApplicationsInsurancePwd(body);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while posting applications insurance pwd", error.response?.data);
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while posting applications insurance pwd", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});